<template>
  <div class="return-layout return">
    <div class="return-section stepper-container">
      <return-stepper
        :step="3"
        :isAtmRefund="true"
        :word="productType === 0 ? '款' : '貨'"
      />
    </div>
    <div class="return-section mt-2">
      <div>訂單編號：</div>
      <div class="order-type">
        <div class="order-id">{{ orderNo }}</div>
        <div v-show="isGroupCoupon" class="product-type">成套票券</div>
        <div v-show="isGroupCoupon" class="text-red return-word">
          成套票券所產生的訂單,未能於兌換期間內將整套/組憑證兌換完畢、或於兌換期間發生退款時,會先將已使用過的憑證轉換為原價,再進行退款相關處理。
        </div>
      </div>
    </div>
    <div class="return-section mt-2 pb-2">
      <v-form ref="formAtm">
        <div class="payment-section">
          <v-row>
            <v-col class="py-0" cols="12">
              <v-text-field
                validate-on-blur
                v-model="atmRefundInfo.AccountName"
                label="帳戶名稱"
                :rules="[specialRule]"
              />
            </v-col>
            <v-col class="py-0" cols="12">
              <v-select
                v-model="atmRefundInfo.BankCode"
                class="v-select--no-label"
                :items="bankItems"
                item-text="name"
                item-value="id"
                label="選擇銀行"
                :rules="[requiredRule]"
                v-on:change="onBankChange($event)"
              />
            </v-col>
            <v-col class="py-0" cols="12">
              <v-select
                v-model="atmRefundInfo.BranchCode"
                class="v-select--no-label"
                :items="branchItems"
                item-text="name"
                item-value="id"
                label="選擇分行"
                no-data-text="請先選擇銀行"
                :rules="[requiredRule]"
                validate-on-blur
                v-on:change="onBranchChange($event)"
              />
            </v-col>
            <v-col class="py-0" cols="12">
              <v-text-field
                validate-on-blur
                v-model="atmRefundInfo.AccountNumber"
                label="銀行帳號"
                :maxlength="14"
                :counter="14"
                :rules="[bankRule]"
              />
            </v-col>
            <v-col class="py-0" cols="12">
              <v-text-field
                ref="buyerMobile"
                type="tel"
                v-model="atmRefundInfo.Phone"
                label="手機號碼"
                :rules="[phoneRule]"
                :maxlength="10"
                :counter="10"
                validate-on-blur
              />
            </v-col>
            <v-col class="py-0" cols="12">
              <v-text-field
                validate-on-blur
                v-model="atmRefundInfo.Id"
                label="身份證字號或統編"
                :maxlength="10"
                :rules="[idRule]"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-0" cols="12">
              <p style="padding:0 .5rem">
                我們將於收到退貨申請後開始處理退款，需再額外等待10~15個工作天。
              </p>
            </v-col>
          </v-row>
        </div>
      </v-form>
      <v-btn
        class="my-2 text-red justify-center"
        block
        color="primary"
        :disabled="!formCheck"
        @click="confirm = true"
      >
        {{ isRedmption ? '確認退款' : '確認退貨' }}
      </v-btn>
    </div>
    <v-overlay opacity=".3" :value="confirm" z-index="13" :dark="false">
      <div style="margin:0 1.2rem">
        <v-card dark="false" :light="false">
          <v-card-subtitle class="text-red">
            請確認填寫資訊無誤後再送出，若您提供錯誤資訊將會影響您的退款權益，謝謝!
          </v-card-subtitle>
          <v-card-subtitle>
            <v-container class="grey lighten-5">
              <v-row no-gutters>
                <v-col cols="6" class="text-head" sm="6">銀行名稱:</v-col>
                <v-col cols="6" sm="6" class="text-body">
                  {{ atmRefundInfo.BankTitle }}
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="6" class="text-head" sm="6">分行別:</v-col>
                <v-col cols="6" sm="6" class="text-body">
                  {{ atmRefundInfo.BranchTitle }}
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="6" class="text-head" sm="6">帳戶名稱:</v-col>
                <v-col cols="6" sm="6" class="text-body">
                  {{ atmRefundInfo.AccountName }}
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="6" class="text-head" sm="6">銀行帳號:</v-col>
                <v-col cols="6" sm="6" class="text-body">
                  {{ atmRefundInfo.AccountNumber }}
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="6" class="text-head" sm="6">手機號碼:</v-col>
                <v-col cols="6" sm="6" class="text-body">
                  {{ atmRefundInfo.Phone }}
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="6" class="text-head" sm="6">
                  身份證字號或統編:
                </v-col>
                <v-col cols="6" sm="6" class="text-body">
                  {{ atmRefundInfo.Id }}
                </v-col>
              </v-row>
            </v-container>
          </v-card-subtitle>
          <v-row no-gutters>
            <v-col cols="6" sm="6">
              <v-btn
                v-on:click="confirm = false"
                outlined
                block
                color="primary"
                class="btn-atmrefund-cancel"
              >
                取消
              </v-btn>
            </v-col>
            <v-col cols="6" sm="6">
              <v-btn
                v-on:click="sendReturnData"
                block
                color="primary"
                class="btn-atmrefund-confirm"
              >
                送出
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </div>
    </v-overlay>
    <WaitingOverlay v-model="submitting" />
  </div>
</template>

<script>
import ReturnStepper from '@/components/return/ReturnStepper.vue'
import WaitingOverlay from '@/components/shared/WaitingOverlay'
export default {
  name: 'ReturnATM',
  components: {
    ReturnStepper,
    WaitingOverlay,
  },
  data() {
    return {
      productType: 0, // redemption: 0 , delivery: 1
      orderNo: '',
      isGroupCoupon: false,
      bankItems: [],
      branchItems: [],
      atmRefundInfo: {
        AccountName: '',
        Id: '',
        BankCode: '',
        BranchCode: '',
        AccountNumber: '',
        Phone: '',
      },
      confirm: false,
      submitting: false,
      returnInfo: null,
    }
  },
  created() {
    this.orderNo = this.$route.query.orderNo
    this.productType = this.$route.query.type
    this.isGroupCoupon = this.$route.query.g
    this.returnInfo = JSON.parse(localStorage.getItem('returnInfo'))
    api.getBanks().then(res => {
      this.bankItems = []
      res.data.forEach(bank => {
        this.bankItems.push({ id: bank.bankNo, name: bank.bankName2 })
      })
    })

    api.getAtmRefundPrefillData(this.orderNo).then(res => {
      this.atmRefundInfo.Id = res.data.comId
      this.atmRefundInfo.Phone = res.data.phone
    })
  },
  methods: {
    onBankChange(value) {
      this.atmRefundInfo.BankTitle = this.bankItems.find(t => {
        return t.id == this.atmRefundInfo.BankCode
      }).name
      api.getBranchs(value).then(res => {
        this.branchItems = []
        res.data.forEach(branch => {
          this.branchItems.push({
            id: branch.branchNo,
            name: branch.branchName2,
          })
        })
      })
    },
    onBranchChange(value) {
      this.atmRefundInfo.BranchTitle = this.branchItems.find(t => {
        return t.id == this.atmRefundInfo.BranchCode
      }).name
    },
    sendReturnData() {
      this.submitting = true
      if (this.isRedmption) {
        this.returnRedemption()
      } else {
        this.returnDelivery()
      }
    },
    goResult(result, reason = '') {
      this.submitting = false
      this.$router.push({
        name: 'returnResult',
        query: {
          success: result,
          type: this.productType,
          isAtmRefund: true,
          reason: reason,
        },
      })
    },
    returnRedemption() {
      api
        .refund(
          this.orderNo,
          this.returnInfo.returnReasonOption == 15
            ? this.returnInfo.returnDetails
            : this.returnInfo.returnReason,
          this.returnInfo.returnReasonOption,
          this.atmRefundInfo
        )
        .then(res => {
          if (res.data.isSuccess) {
            this.goResult(res.data.isSuccess)
          } else {
            this.goResult(false, res.message)
          }
        })
        .catch(err => {
          this.goResult(false)
          console.log(err)
        })
    },
    returnDelivery() {
      api
        .refund(
          this.orderNo,
          this.returnInfo.returnReasonOption == 7
            ? this.returnInfo.returnDetails
            : this.returnInfo.returnReason,
          this.returnInfo.returnReasonOption,
          this.atmRefundInfo,
          this.returnInfo.isReceived,
          this.returnInfo.receiverName,
          this.returnInfo.receiverAddress,
          this.returnInfo.receiverPhone
        )
        .then(res => {
          if (res.data.isSuccess) {
            this.goResult(res.data.isSuccess)
          } else {
            this.goResult(false, res.message)
          }
        })
        .catch(err => {
          this.goResult(false)
        })
    },
    phoneRule: function(value) {
      if (value == null || value == '') return '必填項目'
      const pattern = /09[0-9]{8}/
      return pattern.test(value) || '請輸入正確格式'
    },
    bankRule(value) {
      if (value == null || value == '') return '必填項目'
      const pattern = /[0-9]{14}/
      return pattern.test(value) || '請輸入正確格式'
    },
    idRule(value) {
      if (value == null || value == '') return '必填項目'
      const comId = /^[0-9]{8}$/
      const peopleId = /^[a-zA-Z]{1}[0-9]{9}$/
      if (comId.test(value)) {
        const valArr = [...value]
        const mulArr = [1, 2, 1, 2, 1, 2, 4, 1]
        let sum = 0
        valArr.forEach((num, index) => {
          let mult = num * mulArr[index]
          if (mult > 9) {
            mult = (mult % 10) + parseInt(mult / 10)
          }
          sum += mult
        })
        if (!(sum % 10)) return true
        else if (valArr[6] == 7) {
          if (sum % 10 == 9) return true
        }
        return '錯誤身分證字號或統編'
      } else if (peopleId.test(value)) {
        const letterArr = {
          A: '10',
          B: '11',
          C: '12',
          D: '13',
          E: '14',
          F: '15',
          G: '16',
          H: '17',
          I: '34',
          J: '18',
          K: '19',
          M: '21',
          N: '22',
          O: '35',
          P: '23',
          Q: '24',
          T: '27',
          U: '28',
          V: '29',
          W: '32',
          X: '30',
          Z: '33',
          L: '20',
          R: '25',
          S: '26',
          Y: '31',
        }
        const letterValue = letterArr[value[0].toUpperCase()]
        const idArr = [letterValue[0], letterValue[1], ...value.slice(1)]
        const mulArr = [1, 9, 8, 7, 6, 5, 4, 3, 2, 1, 1]
        let sum = 0
        idArr.forEach((num, i) => {
          sum += num * mulArr[i]
        })
        if (!(sum % 10)) return true
        return '錯誤身分證字號或統編'
      } else {
        return '錯誤身分證字號或統編'
      }
    },
    requiredRule: function(value) {
      if (value == null || value == '') return '必填項目'
      return true
    },
    specialRule: function(value) {
      if (value == null || value == '') return '必填項目'
      const spChar = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/im
      const emoji = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi
      if (spChar.test(value) || emoji.test(value)) {
        return '請輸入正確格式'
      } else {
        return true
      }
    },
  },
  computed: {
    isRedmption() {
      return this.productType == 0
    },
    formCheck() {
      return (
        this.atmRefundInfo.AccountName != '' &&
        this.atmRefundInfo.Id != '' &&
        this.atmRefundInfo.BankCode != '' &&
        this.atmRefundInfo.BranchCode != '' &&
        this.atmRefundInfo.AccountNumber != '' &&
        this.atmRefundInfo.Phone != ''
      )
    },
  },
  watch: {},
}
</script>

<style scoped lang="scss">
.order-type {
  display: flex;
  flex-flow: row wrap;
}
.product-type {
  display: inline-block;
  min-width: 66px;
  height: 17px;
  border-radius: 8px;
  background-color: #fff6e0;
  color: #ff8c00;
  font-size: 12px;
  padding: 0 8px;
  margin: 2px 5px;
}
.return-layout {
  background-color: #f3f3f3;

  .return-section {
    background-color: white;
    box-shadow: 0 1px 0 0 #ededed;
    padding: 16px;
  }

  .stepper-container {
    padding: 0 20px;
  }
}

.return-word {
  color: #1da7fc;
}

.v-card {
  padding: 1rem 0.8rem;
  .v-card__subtitle {
    padding: 0 0.2rem;

    .text-head {
      font-weight: bold;
      text-align: right;
      padding-right: 1rem;
    }
    .text-body {
      text-align: center;
    }
  }
  .v-card__subtitle.text-red {
    color: #f04c44;
  }
}
</style>
